import react, { useState} from "react";
import { useLocation } from "react-router-dom";
import { PopupBookingComponent } from "../../components";
function Booking(){
    const location = useLocation().pathname;
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => setIsModalVisible(true);

  if (location === "/hotel" || location === "/media" || location==="/about-us/ve-mandala"
    || location === "/about-us/muc-tieu-phat-trien" || location === "/about-us/tin-tuc" || location === "/about-us/tuyen-dung"
    || location === "/faqs" || location === "/contact" || location === "/policy" || location === "/profile") {
    return (
      <li className="btnBooking">
        <button className="bookingBtn" onClick={showModal}>Đặt phòng</button>
        <PopupBookingComponent isModalVisible={isModalVisible} setIsModalVisible={setIsModalVisible} />
      </li>
    );
  } else {
    return null;
  }
  
}
export default Booking;